import React from "react";

const DeleteCommonAction = ({ onClick }) => {
  return (
    <button type="button" onClick={() => onClick()} className="btn btn-circle">
      <i className="mdi mdi-trash-can-outline text-danger h4"></i>
    </button>
  );
};

export default DeleteCommonAction;
